// extracted by mini-css-extract-plugin
module.exports = {"container":"_9734efa","skeleton":"_31a0572"};